var version = {
    "name":      "dativery",
    "buildDateCode": "20261105-095554",
    "buildDate": "Thu Nov 05 2026 09:55:54 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261105-095554",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;